module.exports = typeof window == 'object';



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/engine-is-browser.js